<template>
    <div
        ref="wrapper"
        :class="{'has-details': hasDetails, 'timeline-message-highlight': isHighlighted}"
        @mouseover="mouseOverItem"
        @mouseleave="mouseLeaveItem">
        <div :id="anchorId" class="timeline-message-anchor"></div>
        <slot/>
    </div>
</template>

<script>
    import {shortcutTypes} from '@/components/timeline/components/shortcut-types';
    import calculateScrollOffset from '@/common/helpers/calculate-scroll-offset';

    export default {
        name: 'message-item',
        props: {
            messageId: {
                type: String,
                required: true,
            },
            anchorId: {
                type: String,
                required: true,
            },
            hasDetails: {
                type: Boolean,
                required: true,
            },
            isHighlighted: {
                type: Boolean,
                required: true,
            },
        },
        inject: ['shortcutBus'],
        created() {
            this.shortcutBus.$on(shortcutTypes.scrollToEvent, this.scrollIfNeed);
        },
        mounted() {
            if (this.isHighlighted) {
                this.scrollTo();
            }
        },
        methods: {
            mouseOverItem() {
                this.$emit('mouseover');
            },
            mouseLeaveItem() {
                this.$emit('mouseleave');
            },
            scrollIfNeed(id) {
                if (id === this.messageId) {
                    this.scrollTo();
                }
            },
            scrollTo() {
                const node = this.$refs.wrapper;
                const offset = calculateScrollOffset(node, -66); // TODO: calculate header height (56px)?
                window.scrollTo(0, offset);
            },
        },
    };
</script>

<style>
    .timeline-message-anchor {
        position: absolute;
        top: -66px;
    }

    .timeline-comment-message + .timeline-comment-message.timeline-message-highlight {
        padding: 20px 20px 20px 12px;
        padding: 2rem 2rem 2rem 1.2rem;
    }

    .timeline-comment-message.timeline-message-highlight + .timeline-comment-message {
        padding: 20px 20px 20px 12px;
        padding: 2rem 2rem 2rem 1.2rem;
    }

    .timeline-message-highlight {
        outline: 1px solid #0044D4;
        box-shadow: 0 0 0 0.2em rgba(0, 68, 212, 0.51);
        border-radius: 4px;
        z-index: 1;
    }
</style>
